"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _ProductResource = _interopRequireDefault(require("./../../ProductResource"));
var _Authentication = _interopRequireDefault(require("./Authentication"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function GrowthPlan(props) {
  // const { style, type, flexTitle, desc, cardData, videoData, txtData } = props?.productResourceConfiguration;
  var style = props.style;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: 'growth-plan-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement(_Authentication["default"], {
    configuration: props === null || props === void 0 ? void 0 : props.authenticationConfiguration
  }), props.productResourceConfiguration && ( /*#__PURE__*/_react["default"].createElement(_ProductResource["default"], __assign({}, props === null || props === void 0 ? void 0 : props.productResourceConfiguration))));
}
var _default = exports["default"] = GrowthPlan;